export default __webpack_public_path__ + "static/media/MP0053.84f52732.jpg";